import React from "react";
import styled from "@emotion/styled";
import { User } from "react-feather";
import { useNavigate } from "react-router-dom";
import { Tooltip, Menu, MenuItem, IconButton as MuiIconButton } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useAuth } from "../auth/AuthContext";

const IconButton = styled(MuiIconButton)`
  svg {
    width: 22px;
    height: 22px;
  }
`;

function NavbarUserDropdown() {
  const [anchorMenu, setAnchorMenu] = React.useState(null);
  const navigate = useNavigate(); // React Router's navigate hook for redirection
  const { t } = useTranslation();

  const { logout } = useAuth();

  const toggleMenu = (event) => {
    setAnchorMenu(event.currentTarget);
  };

  const closeMenu = () => {
    setAnchorMenu(null);
  };

  const handleProfile = () => {
    closeMenu();
    navigate("/profile");
  };

  const handleLogout = () => {
    // Clear user authentication data, e.g., remove the token from local storage
    // localStorage.removeItem("token"); // Adjust this line as needed based on how you're storing the token

    logout();
    sessionStorage.clear();
    // Redirect the user to the home page or login page
    navigate("/"); // Adjust the path as necessary
    navigate(0);
  };

  return (
    <React.Fragment>
      <Tooltip title={t("Account")}>
        <IconButton
          aria-owns={Boolean(anchorMenu) ? "menu-appbar" : undefined}
          aria-haspopup="true"
          onClick={toggleMenu}
          color="inherit"
          size="large"
        >
          <User />
        </IconButton>
      </Tooltip>
      <Menu id="menu-appbar" anchorEl={anchorMenu} open={Boolean(anchorMenu)} onClose={closeMenu}>
        <MenuItem onClick={handleProfile}>{t("Profile")}</MenuItem>
        <MenuItem onClick={() => handleLogout("redirect")}>{t("Sign out")}</MenuItem>
      </Menu>
    </React.Fragment>
  );
}

export default NavbarUserDropdown;
